import { ActivityLog, ActivityStatusEnum } from "./activity-logs/activity-logs.model";
import { IBindTuningTableColumnHTMLCustom, templateInstallationSourceChannel, templateInstallationSourceType } from "./table.model";
import { getNameInitials } from "./util.model";
import { IWorkflowRequest, IWorkflowRequestLocationInfo, IWorkflowRequestRequestor, WorkflowExecutionStatus, WorkflowRequestStatus } from "./workflow-request.model";
import { InstallationRequestStatus, SourceChannel, SourceType } from "./installation-request-status.model";

export interface IInstallationRequest extends IInstallationRequestFrontEnd {
    //Property that represents where this workflow is allocated in workspace
    workspaceId: string;
    // The product Name
    productName: string;
    // The information about the Workflow Location to do
    location: IWorkflowRequestLocationInfo;
    // The requestor
    requester: IWorkflowRequestRequestor;
    // Property that represents the workflow identifier
    taskId: string;
    // Source Type
    sourceType: SourceType
    // Source Channel
    sourceChannel: SourceChannel
    // The execution status
    executionStatus?: WorkflowExecutionStatus;
    // Contains information about the logs of the installation
    activity?: ActivityLog;

}

export interface IInstallationRequestFrontEnd {
    approversHTMLString?: string; // HTML string for the Approvers part
    approversHTML?: IBindTuningTableColumnHTMLCustom[]; // HTML string for the Approvers part
    statusHTML?: IBindTuningTableColumnHTMLCustom[]; // HTML string for the Status part
    workspacePlatform?: string;
    workspaceName?: string;
    workspaceUrl?: string;
    template?: string;
    requestorName?: string;
    requestorPhoto?: string;
    tableStatus: WorkflowRequestStatus | 'noapprovalrequired';
    normalizedSourceType: string;
    normalizedCatalog: string;
    normalizedConnection: string;
}

export interface IPlainInstallationRequest extends IInstallationRequest {
  type: 'Request';
}

export type ITemplateInstallationRequest = IPlainInstallationRequest | IWorkflowRequest

export function parseInstallationRequestProperties(request: IPlainInstallationRequest) {
    request.workspacePlatform = request.location.type.toLowerCase();
    request.workspaceName = request.location.name
        ? request.location.name
        : request.location.url?.split("/").at(-1);

    request.workspaceUrl = request.location.url;

    request.requestorName = request.requester.name;
    request.requestorPhoto = request.requester.photo;
    request.requester.initials = getNameInitials(request.requester.name);

    request.template = request.productName;

    request.approversHTML = [];
    request.approversHTMLString = `<p class = "text-16 font-mono text-mid-gray-40">-`;

    // request.installationStatus = request.executionStatus ? parseWorkflowExecutionStatus(request.executionStatus) : request.installationStatus
    request.tableStatus = 'noapprovalrequired';
    request.normalizedSourceType = templateInstallationSourceType[request.sourceType]?.label
    if (request.sourceType === SourceType.Catalog) {
        request.normalizedCatalog = templateInstallationSourceChannel[request.sourceChannel]?.label
    }
    else if (request.sourceType === SourceType.Automated) {
        request.normalizedConnection = templateInstallationSourceChannel[request.sourceChannel]?.label;
    }

    return request;
}


export function parseWorkflowExecutionStatus(status: WorkflowExecutionStatus): InstallationRequestStatus{
    switch (status) {
        case WorkflowExecutionStatus.Completed:
        default:
            return InstallationRequestStatus.Success;

        case WorkflowExecutionStatus.Error:
            return InstallationRequestStatus.Failed;

        case WorkflowExecutionStatus.InProgress:
        case WorkflowExecutionStatus.InQueue:
            return InstallationRequestStatus.Running;
        
        case WorkflowExecutionStatus.Cancelled:
            return InstallationRequestStatus.Rejected;
    }
}

export function parseWorkflowRequestStatus(status: WorkflowRequestStatus): InstallationRequestStatus {
    switch (status){
        case WorkflowRequestStatus.Completed:
            return InstallationRequestStatus.Completed;
        case WorkflowRequestStatus.Error:
            return InstallationRequestStatus.Failed;
        case WorkflowRequestStatus.Rejected:
        case WorkflowRequestStatus.Cancelled:
        case WorkflowRequestStatus.Expired:
            return InstallationRequestStatus.Rejected;
        case WorkflowRequestStatus.Pending:
            return InstallationRequestStatus.Pending;
    }
}

export function parseActivityStatus(status: ActivityStatusEnum): WorkflowExecutionStatus {
    switch (status) {
        case ActivityStatusEnum.Applied:
        case ActivityStatusEnum.Completed:
        case ActivityStatusEnum.Downloaded:
        case ActivityStatusEnum.Installed:
        case ActivityStatusEnum.Skipped:
        case ActivityStatusEnum.Updated:
        case ActivityStatusEnum.ReadyToInstall:
        case ActivityStatusEnum.Information:
            return WorkflowExecutionStatus.Completed;

        case ActivityStatusEnum.Error:
        case ActivityStatusEnum.Warning:
        case ActivityStatusEnum.RejectedApproval:
            return WorkflowExecutionStatus.Error;

        case ActivityStatusEnum.Cancelled:
            return WorkflowExecutionStatus.Cancelled;

        case ActivityStatusEnum.InQueue:
        case ActivityStatusEnum.PendingApproval:
            return WorkflowExecutionStatus.InQueue;
            
        case ActivityStatusEnum.InProgress:
            return WorkflowExecutionStatus.InProgress;
    }
}